// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__7QcFK","swiper-wrapper":"Slider_swiper-wrapper__eoFFS","sponsor-swiper":"Slider_sponsor-swiper__7aI+p"};